<template>
  <v-list-item :key="`${tenant.id}_item`" style="background: none">
    <v-list-item-avatar
      :color="isTenantEnabled ? $randomizeColorFromString(tenant.id, 75, 70) : 'grey lighten-2'"
      class="organization-avatar"
    >
      <span class="title text-uppercase font-weight-black white--text">{{ tenant.name.substring(0, 2) }}</span>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-container fluid ma-0 pa-0>
        <v-row align="center" class="fill-height" justify="center" ma-0>
          <v-col :class="!isTenantEnabled ? 'grey--text text--lighten-1' : ''" cols="12" lg="5" sm="6" xl="3">
            {{ tenant.name }}
          </v-col>
          <v-col v-if="$vuetify.breakpoint.smAndUp" lg="7" sm="6" xl="9">
            {{ $t('tenants.statuses.' + tenant.status) }}
            <div v-if="!hasExpired" class="body-2">
              {{ $t('tenants.status_expires') }} {{ $formatDateNoTime(tenant.currentSubscriptionPeriodEnd) }}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu :close-on-content-click="$vuetify.breakpoint.smAndUp" bottom left>
        <template v-slot:activator="{ on }">
          <v-btn class="mt-0 mb-0" color="grey" icon text>
            <v-icon size="28" v-on="on">more_vert</v-icon>
          </v-btn>
        </template>
        <v-list class="pt-0 pb-0" dense>
          <template v-if="$vuetify.breakpoint.xsOnly">
            <v-subheader>{{ $t('tenants.organization_name') }}:</v-subheader>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon size="18">fas fa-users</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{ tenant.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-subheader>{{ $t('tenants.manage_tenant') }}:</v-subheader>
          <v-list-item @click="openTenantUsersManagement">
            <v-list-item-avatar>
              <v-icon>people</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ $t('tenants.users') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="openTenantDetails">
            <v-list-item-avatar>
              <v-icon>settings</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ $t('tenants.settings') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!--                  <v-list-item v-if="isTenantEnabled(tenant)" @click="toggleTenantState(tenant)">-->
          <!--                    <v-list-item-avatar>-->
          <!--                      <v-icon size="18">fas fa-ban</v-icon>-->
          <!--                    </v-list-item-avatar>-->
          <!--                    <v-list-item-content>-->
          <!--                      <v-list-item-title class="font-weight-bold">{{ $t('tenants.disable') }}</v-list-item-title>-->
          <!--                    </v-list-item-content>-->
          <!--                  </v-list-item>-->
          <!--                  <v-list-item v-if="!isTenantEnabled(tenant)" @click="toggleTenantState(tenant)">-->
          <!--                    <v-list-item-avatar>-->
          <!--                      <v-icon size="18">fas fa-check-circle</v-icon>-->
          <!--                    </v-list-item-avatar>-->
          <!--                    <v-list-item-content>-->
          <!--                      <v-list-item-title class="font-weight-bold">{{ $t('tenants.enable') }}</v-list-item-title>-->
          <!--                    </v-list-item-content>-->
          <!--                  </v-list-item>-->
          <v-list-item :disabled="!hasExpired" @click="openTenantPlanDialog">
            <v-list-item-avatar>
              <v-icon size="18">fas fa-check-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ $t('tenants.change_subscription') }} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>
<script>
import dayjs from 'dayjs';

export default {
  name: 'tenant-list-item',
  data() {
    return {
      now: dayjs(),
    };
  },
  props: {
    openTenantDetails: {
      type: Function,
    },
    openTenantPlanDialog: {
      type: Function,
    },
    openTenantUsersManagement: {
      type: Function,
    },
    tenant: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isTenantEnabled() {
      return this.tenant?.status !== 'inactive';
    },
    hasExpired() {
      return (
        this.tenant.currentSubscriptionPeriodEnd == null ||
        (this.tenant.currentSubscriptionPeriodEnd != null && dayjs(this.tenant.currentSubscriptionPeriodEnd).isAfter(this.now))
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.organization-avatar {
  span {
    display: inline-block;
    width: 100%;
  }
}
</style>
